<template>
  <div class="bgf5">
    <iHeader />
    <iNav />
    <iClassify :active="1" AllActive />
    <div class="container">
      <div class="w1200">
        <van-row>
          <van-col :span="15">
            <van-image :src="require('@/assets/download/phone.png')" width="500px" />
          </van-col>
          <van-col :span="9">
            <div class="font-box text-center">
              <h3 class="f36 fw600 c14263A mt0 mb5">药约約APP</h3>
              <h5 class="f24 c14263A mt0 mb0 fw400 mb5">惠聚优质药品</h5>
              <van-icon :name="require('@/assets/download/qrcode.png')" size="276px" class="mt40" />
              <div class="pt20 fw600 c53667B f16 mb5">扫描二维码下载药约約APP</div>
              <!-- <div
                class="pt20 c53667B f16 pt20 mt50 mb5"
                v-if="Info&&Info.VersionCode"
              >最新版本：V{{Info&&Info.VersionCode}}</div>
              <div class="c53667B f16" v-if="Info&&Info.CreateTime">更新日期：{{Info&&Info.CreateTime}}</div> -->
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <iFooter />
  </div>
</template>

<script>
  import iHeader from "@/components/Header";
  import iNav from "@/components/Nav";
  import iClassify from "@/components/Classify";
  import iFooter from "@/components/Footer";
  export default {
    name: "DownLoad",
    components: {
      iHeader,
      iNav,
      iFooter,
      iClassify
    },
    data() {
      return {
        Info: null
      };
    },
    mounted() {
      this.getAppVer();
    },
    methods: {
      getAppVer() {
        this.getAction("/api_appversionupdate/AppVersionUpdate/GetLast").then(
          res => {
            if (res.IsSuccess && res.Data) {
              this.Info = res.Data;
            }
          }
        );
      }
    }
  };
</script>

<style scoped lang="less">
  .container {
    width: 100%;
    height: 900px;
    background: url("../../assets/download/bg.png") no-repeat;
    background-size: 100% 900px;

    >div {
      margin: 0 auto;

      .font-box {
        width: 276px;
      }

      /deep/.van-row {
        position: relative;
        top: 100px;
      }
    }
  }

  .c53667B {
    color: #53667b;
  }

  .c14263A {
    color: #14263a;
  }
</style>